import React from "react";
import Slider from "react-slick";

const VisaSlider = () => {
  return (
    <div className="visa-slider">
      {/* Slide Content */}
      <div className="slider-content">
        <div className="text-section">
          <h1 style={{ color: "#b50808" }}>
            Welcome to Rojan Canada Incorporation
          </h1>
          <h5>
            Rojan Canada Incorporation empowers businesses across Canada with reliable, innovative
             solutions. As a trusted importer and distributor of premium Indian spices, grains, 
             and specialty products, we offer expert supply chain support along with tailored 
             consulting, marketing, and operational services. Whether you're a retailer, 
             restaurant, wholesaler, or entrepreneur, we help you thrive with authentic products 
             and dedicated service.
          </h5>
        </div>
        <div className="image-section">
          <img src="images/partner.jpg" alt="Empowering Your Business" />
          <div className="apply-now" style={{textAlign:'center'}}>
            <h4>Partner with Us to Propel Your Business to New Heights!</h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisaSlider;